import * as React from 'react';
import { Link, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { black, white } from '../getLPTheme';


export default function Copyright() {
    return (
        <Box component="footer" sx={{ p: 2, bgcolor: black[1000] }}>
            <Typography variant="body2" color= {white[50]} align="center">
                {'Copyright © '}
                <Link color="inherit" href="/">
                World Golf Club
                </Link>{' '}
                {new Date().getFullYear()}.
            </Typography>
        </Box>
    );
}
